import {useMinimumQuantity} from "../../../../hooks/useMinimumQuantity";
import {useScreenSizeDetector} from "../../../../hooks/useScreenSizeDetector";
import * as React from "react";
import {CommonCardLayout} from "./commonCardLayout";
import {Button, InputGroup} from "react-bootstrap";
import {Favorites} from "../favorites";
import {MinimumQuantityNotice} from "./minimumQuantityNotice";
import {useProductDetailsQuery} from "../../../../hooks/useProductDetailsQuery";
import {useAppContext} from "../../../../hooks/useAppContext";
import {artworkOffCanvasActions} from "../../../../redux/slices/artworkOffCanvas";
import {useAppDispatch} from "../../../../redux/stateHooks";
import {useQuantity} from "../../../../hooks/useQuantity";

export const MobileArtwork = () => {
    const {isSmallScreenSize} = useScreenSizeDetector();
    const dispatch = useAppDispatch();
    const {model: {sku, artworkGuidelineTypePath}} = useProductDetailsQuery();
    const {productId} = useAppContext();
    const {minimumSaleQuantity} = useMinimumQuantity();
    const {quantity} = useQuantity();

    return (
        <CommonCardLayout isSmallScreenSize={isSmallScreenSize}>
            <div className="mb-2 px-3" style={{fontSize: '0.9em'}}>
                Upload your artwork now, or later.

                <a href={artworkGuidelineTypePath} target="_blank" className={'d-block'} tabIndex={0} role="link"
                   aria-label="View templates & guidelines">
                    View templates & guidelines
                </a>
            </div>
            <InputGroup>
                <Button
                    variant="warning"
                    size='lg'
                    onClick={async () => dispatch(artworkOffCanvasActions.setShow(true))}
                    className={`flex-fill add-to-cart-btn ms-1 px-0 fs-5`}
                    data-ee-list={`ProductNew | Details`}
                    data-react="true"
                    data-item-id={productId}
                    data-quantity={quantity}
                    data-sku={sku}
                >
                    Get Started
                </Button>
                <Favorites/>
            </InputGroup>
            {minimumSaleQuantity > 1 && <MinimumQuantityNotice minimumQuantity={minimumSaleQuantity}/>}
        </CommonCardLayout>
    );
};